import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import PropTypes from 'prop-types';
import React from 'react';

const KeyboardDateInput = ({
  autoOk = false,
  clearable = true,
  dateFormat = undefined,
  defaultToNow = true,
  disabled,
  disableFuture = false,
  input: { value, onChange },
  label = undefined,
  maxDateMessage = undefined,
  placeholder = undefined,
  showTodayButton = false,
}) => {
  let normalizedValue = typeof value === 'string' && value.length > 0 && value[0] !== '0' ? new Date((new Date(value.split('-'))).toDateString()) : value && typeof value === 'object' && value.toDateString ? new Date((new Date(value.getFullYear(), value.getMonth(), value.getDate(), 0, 0, 0, 0)).toDateString()) : value;
  
  if (!value && defaultToNow) {
    onChange(new Date());
    return null;
  }

  if (!value && !defaultToNow) {
    normalizedValue = null;
  }

  const processOnChange = date => {
    try {
      const theDate = new Date(date.getTime());
      theDate.setHours(0,0,0,0);
      onChange(theDate.toISOString().split('T')[0]);
    } catch (error) {
      onChange(date);
    }
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        autoOk={autoOk}
        clearable={clearable}
        disableFuture={disableFuture}
        disabled={disabled}
        format={dateFormat}
        label={label}
        maxDateMessage={maxDateMessage}
        placeholder={placeholder}
        showTodayButton={showTodayButton}
        value={normalizedValue}
        onChange={processOnChange}
      />
    </MuiPickersUtilsProvider>
  );
};

KeyboardDateInput.propTypes = {
  autoOk: PropTypes.bool,
  clearable: PropTypes.bool,
  dateFormat: PropTypes.string,
  defaultToNow: PropTypes.bool,
  disabled: PropTypes.bool,
  disableFuture: PropTypes.bool,
  input: PropTypes.object,
  label: PropTypes.string,
  maxDateMessage: PropTypes.string,
  placeholder: PropTypes.string,
  showTodayButton: PropTypes.bool,
};

export default KeyboardDateInput;
